module.exports = __webpack_public_path__ + "img/facility-ico.5f46e4ae.svg";